import React from 'react'

const QidaLogo: React.FC = () => {
  return (
    <img
      src="/assets/images/qida-logo.png"
      alt="Qida Logo"
      className="w-[160px] h-[72px]"
    />
  )
}

export default QidaLogo
